export enum ConfigurationItem {
  ANIMAL_CATEGORY,
  CAUSE_OF_DEATH,
  CORRAL_LISTING,
  FARM_GOALS,
  FORMULATIONS,
  HERD_EVOLUTION_AND_NUTRITION_PLAN,
  INGREDIENTS,
  LOT_GOALS,
  PLOT_LISTING,
  RAIN_HISTORY,
  SCORE_ADJUSTMENT,
  WEIGHING_BY_CATEGORY,
  WEIGHT_GAIN_CURVE,
}
